module.exports = __webpack_public_path__ + "static/media/IMG_3327-min.e8432a4a.JPG";